import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

const Quest = () => {
  const navigate = useNavigate();
  const [twitterConnected, setTwitterConnected] = useState(false);
  const [discordConnected, setDiscordConnected] = useState(false);
  const [faucetClaimed, setFaucetClaimed] = useState(false);
  const [swapCompleted, setSwapCompleted] = useState(false);
  const [allQuestsCompleted, setAllQuestsCompleted] = useState(false);

  useEffect(() => {
    const checkConnections = () => {
      setTwitterConnected(localStorage.getItem('twitterConnected') === 'true');
      setDiscordConnected(localStorage.getItem('discordConnected') === 'true');
      setFaucetClaimed(localStorage.getItem('faucetClaimed') === 'true');
      setSwapCompleted(localStorage.getItem('swapCompleted') === 'true');
    };
    checkConnections();
  }, []);

  useEffect(() => {
    setAllQuestsCompleted(twitterConnected && discordConnected && faucetClaimed && swapCompleted);
  }, [twitterConnected, discordConnected, faucetClaimed, swapCompleted]);

  const quests = [
    {
      id: 1,
      title: "Follow Prior Protocol on Twitter",
      description: "Follow our official Twitter account to stay updated with the latest news and announcements",
      completed: twitterConnected,
      action: () => {
        window.open('https://x.com/priorprotocol', '_blank');
        localStorage.setItem('twitterConnected', 'true');
        setTwitterConnected(true);
      }
    },
    {
      id: 2,
      title: "Join Prior Protocol on Discord",
      description: "Become part of our community as an early adopter and connect with other members",
      completed: discordConnected,
      action: () => {
        window.open('https://discord.gg/priorprotocol', '_blank');
        localStorage.setItem('discordConnected', 'true');
        setDiscordConnected(true);
      }
    },
    {
      id: 3,
      title: "Claim Test PRIOR Tokens",
      description: "Get test tokens from our faucet (Limit: 1 claim per day). You'll need some tokens to complete other quests",
      completed: faucetClaimed,
      action: () => {
        navigate('/faucet');
        localStorage.setItem('faucetClaimed', 'true');
        setFaucetClaimed(true);
      }
    },
    {
      id: 4,
      title: "Swap on Prior Testnet DEX",
      description: "Acquire and hold PRIOR tokens in your wallet (Ensure you're connected to Base Sepolia network)",
      completed: swapCompleted,
      action: () => {
        navigate('/swap');
        localStorage.setItem('swapCompleted', 'true');
        setSwapCompleted(true);
      }
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-700/50 shadow-xl hover:shadow-[#00df9a]/10 transition-all duration-300 mb-8 text-center">
          <h1 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#00df9a] to-blue-400 mb-3">PRIOR QUESTS</h1>
          <p className="text-gray-300 text-lg">Complete all quests to unlock your Guild rewards</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {quests.map((quest) => (
            <div 
              key={quest.id} 
              className={`bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl border transition-all duration-300 flex flex-col ${
                quest.completed 
                  ? 'border-green-500/30 shadow-green-500/10' 
                  : 'border-gray-700/50 hover:border-[#00df9a]/30 shadow-xl hover:shadow-[#00df9a]/10'
              }`}
            >
              <div className="flex-1">
                <h3 className={`text-xl font-bold mb-4 ${
                  quest.completed ? 'text-green-400' : 'text-[#00df9a]'
                }`}>
                  {quest.title} {quest.completed && <span className="ml-2 text-green-400">✓</span>}
                </h3>
                <p className="text-gray-300 mb-6">{quest.description}</p>
              </div>
              <button
                onClick={quest.action}
                className={`mt-auto w-full ${
                  quest.completed 
                    ? 'bg-green-600/20 text-green-400 border border-green-400/30 cursor-default' 
                    : 'bg-gradient-to-r from-[#00df9a] to-blue-500 hover:from-[#00c78a] hover:to-blue-400 text-black'
                } font-bold py-3 px-6 rounded-xl transition-all duration-300`}
                disabled={quest.completed}
              >
                {quest.completed ? 'Completed' : 'Start Quest'}
              </button>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => window.open('https://guild.xyz/prior-protocol-a7e79a', '_blank')}
            className={`w-full max-w-md mx-auto bg-gradient-to-r from-purple-600 to-indigo-500 hover:from-purple-700 hover:to-indigo-600 text-white font-bold py-3 px-6 rounded-xl transition-all duration-300`}
          >
            {allQuestsCompleted ? 'Submit on Guild' : 'Complete All Quests First'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Quest;
